import React, {useState, useEffect, useRef, useCallback} from 'react';  
import { translate, resolveRouterPath, getUpdatedPageUrl, getSearchQuery, isEmptyChk } from 'utils/common';
import { S_KEY,   C_KEY, P_ITEMS_LIMIT, LIMIT } from 'utils/constants'; 
import dataService from 'utils/dataservice'; 
import SelectField from 'components/common/selectfield';
import AutoSuggestWrapper from './autoSuggest/autoSuggestWrapper';
import FilterField from 'components/filterfield';  
// import ProductSuggestWrapper from './autoSuggest/productSuggestWrapper';
function Search(props){
    const [state, setState] = useState({category:null, searchValue: "" });
    const isSubmitRequired = useRef(false);

    useEffect(()=>{
        setState({
            searchValue: props.defaultSearch ? (!isEmptyChk(props.defaultSearch.codes) ? props.defaultSearch.codes : props.defaultSearch.term) :"",
            category: props.defaultSearch ? (!isEmptyChk(props.defaultSearch.field) ? props.defaultSearch.field: !isEmptyChk(props.defaultSearch.fields)?props.defaultSearch.fields[0]:null) :  props.defaultSearchValue || null})
    },[props.defaultSearch, props.instance, props.defaultSearchValue]);

    useEffect(()=>{
        if(isSubmitRequired.current) {
            isSubmitRequired.current = false
            submit();
        }
    },[state, submit])
    // useEffect(()=>{
    //     searchValue.current = null
    // },[props.instance])

    function updateStateByKey(key, value){
        setState(prevState=>{
            return {...prevState, ...{[key]: value}}
        })
    }
    function changeCategory(e){
        // category.current = e.target.value;
        // searchValue.current = "";
        if(!e.target.value) isSubmitRequired.current = true
        setState({searchValue: "",
                        category: e.target.value});
        if(props.onCategoryChange)props.onCategoryChange(e.target.value, props.uId)
        ///Call submit when dropdown clears or 'select value' selected
        // if(!e.target.value) submit();
    }
    function searchKeyPress(e){ 
        if (e.key == 'Enter') {
            submit();
        }
    } 
    const submit= useCallback(()=>{ 
        let query = {};      
        
        let sq = {}// getSearchQuery({}, query, null, state.category);
        if(state.category && ["multiselect", "select"].includes(props.searchCategoryOptions.find(item=>item.value==state.category).fieldtype)){
            // query = { [C_KEY]: state.category+":"+state.searchValue+":category", [S_KEY]: state.searchValue };
            query = { [C_KEY]: state.category+":"+state.searchValue };
            sq = getSearchQuery({}, query, null, state.category);
            if(!sq.f[0].codes[0].length || sq.f[0].codes[0]=="null"){
                ///if codes[] is empty
                delete sq.f
            }
            // sq = getSearchQuery({[state.category]: {"codes":[state.searchValue]}}, query, null, state.category);
        }else {
            query[S_KEY]= state.searchValue;
            sq = getSearchQuery({}, query, null, state.category);
        }
        props.onChange(sq, props.uId);
    },[props, state])
    async function onSuggestionsFetchRequested(value){
        return await props.onSuggestionsFetchRequested(value, state.category)
    }
    function suggestionChange(e){
        ///This will be an object if autosuggest is selected from suggestino dropdown. on pressing enter, it will be a string
        isSubmitRequired.current = true
        //updateStateByKey("searchValue", typeof(e.target.value) == "object" ? e.target.value[state.category] || e.target.value["display_name"] : e.target.value);
        updateStateByKey("searchValue", typeof(e.target.value) == "object" ? e.target.value[state.category] : e.target.value);
        // submit();
    }
    function changeCategoryValue(e){
        isSubmitRequired.current = true;
        let value = e.target.value;
        if(typeof(e.target.value)=="array" && isEmptyChk(e.target.value)) value = ""
        updateStateByKey("searchValue", value );        
        // submit();
    }
    function onInputChange(e){
        updateStateByKey("searchValue",  e.target.value);  
    }
    function searchKeyPress(e) {
        if (e.key == 'Enter') {
            e.preventDefault();
            // searchValue.current = e.target.value; 
            isSubmitRequired.current = true
            updateStateByKey("searchValue",  e.target.value);
            // submit();
        } 
    }
    function getSelectedCategoryOptions(){
        return props.searchCategoryOptions.find(item=>item.value==state.category).options
    }
    function generateAutoSuggestDisplayName(model){
        if (state.category && state.category === 'display_name') {
            return model.display_name;
        }
        return model.display_name + (model[state.category] ? ` ( ${model[state.category]} )` : '');
    }
    return(
        <div className="main-search">
                <div className="input-group main-search-select">
                    {/* <div className="select-container nav-list"> */}
                        {/* <span className="current-selection">{currentSelection}</span> */}
                        {/* <span className="arrow"></span> */}
                        {/* <select onChange={changeCategory} >
                            //<option key="ALL" value={DEFAULT_CATEGORY}>{translate("buyer.menus.all_categories")}</option>  
                            {props.searchCategories.map(category => 
                                <option key={category['value']} value={category['value'] || ''} className={category.isSubCategory?'d-none':''}>{category['label']}</option>
                            )}
                        </select> */}
                    <SelectField prependSelectValue={true} onChange={changeCategory} value={state.category || ""} 
                                        options={props.searchCategoryOptions} />
                                        {/* options={props.searchCategoryOptions} defaultValue={searchValue.current} /> */}
                        {/* <i className="icon-downarrow noc-drop" aria-hidden="true"></i>
                    </div> */}
                    {/* <Autosuggest theme={this.theme} suggestions={suggestions} onSuggestionSelected={this.onAutoSuggestionSelected} onSuggestionsFetchRequested={this.onAutoSuggestionsFetchRequested} onSuggestionsClearRequested={this.onAutoSuggestionsClearRequested} getSuggestionValue={this.getAutoSuggestionValue} renderSuggestion={this.renderAutoSuggestion} inputProps={inputProps} /> */}
                    {/* <input onKeyPress={searchKeyPress} onChange={onSearchChange} className="form-control" /> */}
                    {state.category && props.searchCategoryOptions.find(item=>item.value==state.category).fieldtype == "autosuggest" 
                        && <AutoSuggestWrapper onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                                        name={state.category}
                                        displayNameFun={generateAutoSuggestDisplayName}
                                        onChange={suggestionChange}
                                        defaultValue={state.searchValue}
                                        /> }

                    <form className="form-online">
                        <div className="form-group btn-min-width">
                            {state.category && 
                                <React.Fragment>
                                    {props.searchCategoryOptions.find(item=>item.value==state.category).fieldtype == "multiselect" 
                                        && <FilterField data={getSelectedCategoryOptions()} hideLabel={true}
                                            field={state.category} type="multiselect"
                                            defaultValue={state.searchValue} onChange={changeCategoryValue}
                                        />
                                    }

                                    {props.searchCategoryOptions.find(item=>item.value==state.category).fieldtype == "select" 
                                        && <SelectField prependSelectValue={true} onChange={changeCategoryValue}
                                            options={getSelectedCategoryOptions()} searchable={true}
                                            defaultValue={state.searchValue} />}
                                    {(props.searchCategoryOptions.find(item=>item.value==state.category).fieldtype == "input"
                                        || !props.searchCategoryOptions.find(item=>item.value==state.category).fieldtype)
                                        &&  <input placeholder="Search" className="form-control width-100"
                                            onKeyPress={searchKeyPress}  onChange={onInputChange}
                                            type="text" value={state.searchValue} />} 
                                </React.Fragment>
                            }
                        </div>
                    </form>
                    {/* <div className="input-group-append">
                        <button className="btn border-0 align-items-center d-flex" type="button" onClick={submit}>
                            <i className="icon-search-icon align-self-center"></i>
                        </button>
                    </div> */}
                </div>
            </div>
    )
}
export default Search; 